// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".record-filter-popover[data-v-10272bb5]{min-width:280px}.record-filter-popover[data-v-10272bb5] .popover-body{padding-top:.5rem}", ""]);
// Exports
module.exports = exports;
